/* import __COLOCATED_TEMPLATE__ from './current-transfer-review.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { Account } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
import { EstimatedTransferEvent } from '@square/dashboard-protos/models/squareup/sfs/models/estimated_transfer_event';
let CurrentTransferReview = (_dec = computed('currentTransfer.primaryAccount.name'), _dec2 = computed(), _dec3 = computed('currentTransfer.secondaryAccount'), _dec4 = computed('currentTransfer.secondaryAccount.bankName', 'locationSelector.units'), _dec5 = computed('currentTransfer.secondaryAccount.accountNumberSuffix', 'locationSelector.units'), _dec6 = computed('currentTransfer.isDeposit', 'isInstantTransfer'), _dec7 = computed('transferEvents'), _dec8 = computed('transferEvents'), _dec9 = computed('transferEvents'), _dec10 = computed('currentTransfer.{isDeposit,isFolderToFolderTransfer,remainingWeeklyDeposits}'), _dec11 = computed('currentTransfer.{isDeposit,isFolderToFolderTransfer,remainingWeeklyWithdrawals}'), _class = class CurrentTransferReview extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentTransfer", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "locationSelector", _descriptor3, this);
    _initializerDefineProperty(this, "features", _descriptor4, this);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "transferEvents", void 0);
  }
  get primaryAccountLabel() {
    return this.currentTransfer.primaryAccount?.name;
  }
  get primaryAccountExtra() {
    return '';
  }
  get isInstantTransfer() {
    if (this.currentTransfer.secondaryAccount instanceof Account) {
      return true;
    } else {
      return false;
    }
  }
  get secondaryAccountLabel() {
    const account = this.currentTransfer.secondaryAccount;
    if (account === null) {
      throw new Error('cannot render null secondary account in transfer review');
    } else if (account instanceof Account) {
      if (account.type === AccountType.SAVINGS_ACCOUNT) {
        return account.name;
      }
      return this.locationSelector.units.find(unit => {
        if (account.owner) {
          return unit.token === account.owner.id;
        } else {
          return false;
        }
      })?.nickname;
    } else {
      return account.bankName;
    }
  }
  get secondaryAccountExtra() {
    const account = this.currentTransfer.secondaryAccount;
    if (account === null) {
      throw new Error('cannot render null secondary account in transfer review');
    } else if (account instanceof Account) {
      return '';
    } else {
      return account.accountNumberSuffix;
    }
  }
  get processingTime() {
    if (this.isInstantTransfer) {
      return this.intl.t('sfs.shared.transfers.confirm.processing.value.instant');
    }
    if (this.currentTransfer.isDeposit) {
      return this.intl.t('sfs.shared.transfers.confirm.processing.value.deposit');
    } else {
      return this.intl.t('sfs.shared.transfers.confirm.processing.value.withdraw');
    }
  }
  get willInitiateAt() {
    return this.transferEvents.find(event => {
      return event.type === EstimatedTransferEvent.Type.INITIATED;
    })?.estimatedTime;
  }
  get willSettleAt() {
    return this.transferEvents.find(event => {
      return event.type === EstimatedTransferEvent.Type.SETTLED;
    })?.estimatedTime;
  }
  get willBeAvailableAt() {
    return this.transferEvents.find(event => {
      return event.type === EstimatedTransferEvent.Type.MADE_AVAILABLE;
    })?.estimatedTime;
  }
  get showDepositRemainingTransfers() {
    return !this.currentTransfer.isFolderToFolderTransfer && this.currentTransfer.isDeposit && this.currentTransfer.remainingWeeklyDeposits != null;
  }
  get showWithdrawalRemainingTransfers() {
    return !this.currentTransfer.isFolderToFolderTransfer && !this.currentTransfer.isDeposit && this.currentTransfer.remainingWeeklyWithdrawals != null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentTransfer", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "primaryAccountLabel", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "primaryAccountLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "primaryAccountExtra", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "primaryAccountExtra"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInstantTransfer", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "isInstantTransfer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondaryAccountLabel", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "secondaryAccountLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondaryAccountExtra", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "secondaryAccountExtra"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processingTime", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "processingTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willInitiateAt", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "willInitiateAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willSettleAt", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "willSettleAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "willBeAvailableAt", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "willBeAvailableAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDepositRemainingTransfers", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "showDepositRemainingTransfers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWithdrawalRemainingTransfers", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "showWithdrawalRemainingTransfers"), _class.prototype), _class);
export { CurrentTransferReview as default };